import React from 'react';
import ReactPlayer from 'react-player';
import { PlayButton } from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import Caption from './caption';

const VideoWrapper = styled('div')(() => ({
  // this serves to take up all available space on the slide
  // so the caption can decide whether it affects height
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  flexGrow: 1,
}));

const VideoPlayer = styled(ReactPlayer)(({ theme }) => ({
  // full viewport, minus margins OR an approximation of 16:9 with height
  width: `min(100vw - ${theme.spacing(4)}, (100vh - 220px) / 0.5625)`,
  // 16:9 with width OR available height if smaller
  height: `min((100vw - ${theme.spacing(4)}) * 0.5625, 100%)`,
  margin: theme.spacing(2),
}));

const ThumbWrapper = styled('div')(({ theme }) => ({
  pointerEvents: 'none',
  background: theme.palette.common.black,
  height: '100%',
  width: '90px',
  [theme.breakpoints.up('sm')]: {
    width: '150px',
  },
  [theme.breakpoints.up('md')]: {
    width: '200px',
  },
}));

const PlayIcon = styled(PlayButton)(({ theme }) => ({
  fontSize: '2em',
  [theme.breakpoints.up('sm')]: {
    fontSize: '3em',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '4em',
  },
}));

export function VideoFull(props) {
  const { url, caption, playing = false } = props;
  return (
    <>
      <VideoWrapper>
        <VideoPlayer
          src={url}
          controls
          width=''
          height=''
          wrapper='div'
          playing={playing}
        />
      </VideoWrapper>
      {caption && <Caption>{caption}</Caption>}
    </>
  );
}

export function VideoThumb(props) {
  const { url } = props;
  return (
    <ThumbWrapper>
      <ReactPlayer
        src={url}
        light
        playIcon={<PlayIcon />}
        width='100%'
        height='100%'
        wrapper='div'
      />
    </ThumbWrapper>
  );
}
